function NotFoundPage() {
    return ( 
        null
     );
}

export default NotFoundPage;